var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"from-boti":false,"title":'תמונת החודש הראשונה שלך מוכנה!',"text":'אפשר לערוך את ההוצאות וההכנסות בלחיצה על כפתור העריכה ✏️',"notification-buttons":[
                  {
                    size:'normal',
                    title:'איך נבנתה תמונת החודש?',
                    subTitle: 'אפשר לקרוא כאן הסבר מפורט',
                    variant: 'primary',
                    action: _vm.openTour,
                  } ]}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24e2c088","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/notification/notification-types/NewCashflowTourNotification.vue
// module id = null
// module chunks = 